import React, { Component } from 'react';
import PropTypes from "prop-types";
import VisibilitySensor from "react-visibility-sensor";

class BannerTwo extends Component {
    render() {
        return (
            <>
                <div id="home" className="home-video-area">
                    <video autoPlay="autoplay" loop="loop" id="bgvid">
                        <source src={this.props.VideoLink} type="video/mp4"/> 
                    </video> 
                
                    <div className="video-text-area">
                        <VisibilitySensor>
                            {({ isVisible }) => (
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-7">
                                        <span
                                            className={
                                                isVisible
                                                    ? "hero-text animated fadeInDown slow opacityOne"
                                                    : "opacityZero"
                                            }
                                        >
                                            {this.props.TopTitle}
                                        </span>

                                        <h1
                                            className={
                                                isVisible
                                                    ? "animated fadeInDown slow opacityOne"
                                                    : "opacityZero"
                                            }
                                        >
                                            {this.props.Title}
                                        </h1>
                                        <p
                                            className={
                                                isVisible
                                                    ? "animated fadeInDown slow opacityOne"
                                                    : "opacityZero"
                                            }
                                        >
                                            {this.props.Content}
                                        </p>
                                        <div className="center-wrap">
                                            <a href={this.props.BtnLink} className="btn-a">
                                                <div className="button">
                                                    {this.props.BtnName}
                                                    <i className="icofont-long-arrow-right" />
                                                <div className="mask" /></div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        </VisibilitySensor>
                    </div>
                </div>    
            </>
        );
    }
}
//Props Types
BannerTwo.propTypes = {
    VideoLink: PropTypes.string,
    TopTitle: PropTypes.string,
    Title: PropTypes.string,
    Content: PropTypes.string,
    BtnLink: PropTypes.string,
    BtnName: PropTypes.string,
};

//Default Props
BannerTwo.defaultProps = {
    VideoLink: "https://trynext-react.envytheme.com/video/promo-video.mp4",
    TopTitle: "Clean & Creative",
    Title: "Fully Responsive Design",
    Content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ac augue at erat hendrerit dictum. Praesent porta, purus eget sagittis imperdiet.",
    BtnLink:  "#contact",
    BtnName: "get started",
};
export default BannerTwo;
